import { globalVariables } from "helper/globalVariables";

export const TrailStatus = [
  globalVariables.approve,
  globalVariables.reject,
  globalVariables.pending,
];
